import { Keys, Scene } from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import Professor from "../actors/characters/professor";
import CutSceneManager from "../cutSceneManager";
import BeeClassManager from "../beeClassManager";
import { playerState } from "../state/stateManager";
import { goToScene } from "../main";
import { createGainedItem, sendAlert } from "../utils";

export default class BeeClass extends Scene {
  constructor() {
    super();
    this.player = new Player(6 * 16, 8 * 16);
    this.professor = new Professor({ x: 5 * 16, y: 6 * 16 });
    this.player.z = 5;
    this.professor.z = 5;
  }

  onInitialize(engine) {
    Resources.BeeClubMap.addToScene(this);
    Resources.AppleCider.stop();

    this.engine = engine;
    console.log("beeClub: adding player: ", this.player);
    this.player.lastDir = "up";
    this.camera.zoom = 2;

    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.professor);
    this.camera.strategy.lockToActor(this.player);
    this.player.wearingVeil = false;
    this.player.cutScene = true;
    this.professor.cutScene = true;
  }
  onActivate(data) {
    this.content = playerState.getContent();
    this.classData = data.data;

    switch (this.classData) {
      case "beekeeping101":
        this.startCutscene(
          this.content.beeClasses.classes.hiveManagementClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "honey101":
        this.startCutscene(
          this.content.beeClasses.classes.honeyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "honeyHarvesting":
        this.startCutscene(
          this.content.beeClasses.classes.honeyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "honeySales":
        this.startCutscene(
          this.content.beeClasses.classes.honeyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "honeyProduction":
        this.startCutscene(
          this.content.beeClasses.classes.honeyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "biology101":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "mites":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "queenProduction":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "swarms":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "pheromones":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "beeSeason":
        this.startCutscene(
          this.content.beeClasses.classes.biologyClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "hiveSpaceManagement":
        this.startCutscene(
          this.content.beeClasses.classes.hiveManagementClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "feeding":
        this.startCutscene(
          this.content.beeClasses.classes.hiveManagementClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      case "winterPrep":
        this.startCutscene(
          this.content.beeClasses.classes.hiveManagementClasses.find(
            (item) => item.id == data.data
          )
        );
        break;
      default:
        break;
    }
  }
  setClassToState() {
    this.content = playerState.getContent();
    if (this.classData == "beekeeping101") {
      if (
        this.content.beeClasses.completed.find(
          (item) => item == "beekeeping101"
        )
      ) {
        return;
      } else {
        this.content.beeClasses.completed.push("beekeeping101");
        this.content.achievements.push("firstClass");
        this.content.beeClasses.signedUp = null;
        createGainedItem("First Class Achievement");
      }
    } else {
      if (
        !this.content.beeClasses.completed.find(
          (item) => item == this.classData
        )
      ) {
        this.content.beeClasses.completed.push(this.classData);
      }

      this.content.beeClasses.signedUp = null;
    }
  }
  startCutscene(data) {
    this.player.cutScene = true;
    this.cutSceneBoolean = true;
    this.cutScene = new BeeClassManager(
      data.content,
      this.professor,
      this.player,
      () => {
        console.log("cutscene: endScene()");
        this.cutSceneBoolean = false;
        this.cutScene = null;
        this.player.cutScene = false;
        this.professor.cutScene = false;
        this.setClassToState();

        goToScene("beeClub");
      }
    );
    this.cutScene.startScene();
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.cutSceneBoolean) {
        this.cutScene.enterPress();
      }
    }
  }
}
